import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchDataStart, fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { activePlanApi, addPlanApi, editPlanApi, getAppOverViewDetails } from '../../dev_services/developer/api';
import { ToastContainer, toast } from 'react-toastify';
import { Switch } from '@mui/material';
import { PlusIcon, EditIcon } from '@shopify/polaris-icons';
import { BlockStack, Button, Card, InlineGrid, Text, Select, TextField, Label } from '@shopify/polaris';
import NoDataFound from '../../dev_components/nodatafound/no_data_found';
import "../dev_plans/dev_plan.scss";

const DevPlan = () => {
  const { appID } = useParams();
  const dispatch = useDispatch();
  const appsResponseData = useSelector((state: any) => state.appsOverviewSlice);
  const { data, loading, error } = appsResponseData;
  const [plansFromApi, setPlansFromApi] = useState<any[]>([]);
  const [editingPlanIndex, setEditingPlanIndex] = useState(-1);
  const [editedPlans, setEditedPlans] = useState<any[]>([]);
  const [otherValidityValue, setOtherValidityValue] = useState("");
  const [isOtherValiditySelected, setIsOtherValiditySelected] = useState(false);
  const [isOtherPercentageValiditySelected, setIsOtherPercentageValiditySelected] = useState(false);

  const [enablePricePlans, setEnablePricePlans] = useState(false);
  const [enablePlansDuration, setEnablePlansDuration] = useState(false);
  const [enablePlansChargeAt, setEnablePlansChargeAt] = useState(false);
  const [enablePaymentType, setEnablePaymentType] = useState(false);
  const [enableFlat, setEnableFlat] = useState(false);
  const [enablePercentage, setEnablePercentage] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(fetchDataStart());
        const response = await getAppOverViewDetails(appID);
        const slugName = response.slug;
        localStorage.setItem('slug', slugName);
        dispatch(fetchDataSuccess(response));
        if (response && response.plans) {
          setPlansFromApi(response.plans);
          setEditedPlans(response.plans.map((plan: any) => ({ ...plan })));
        }
      } catch (error) {
        toast.error("Error fetching data");
      }
    };

    if (!data) {
      fetchData();
    } else {
      setPlansFromApi(data.plans);
      setEditedPlans(data.plans.map((plan: any) => ({ ...plan })));
    }
  }, [dispatch, appID, data]);

  const activatePlan = async (data) => {
    try {
      dispatch(fetchDataStart());
      const activateResponse = await activePlanApi(appID, data);
      if (activateResponse.data.status_code === 200) {
        toast.success(activateResponse.data.result.message);
        const response = await getAppOverViewDetails(appID);
        dispatch(fetchDataSuccess(response));
        setPlansFromApi(response.plans);
        setEditedPlans(response.plans.map((plan: any) => ({ ...plan })));
      } else {
        toast.error(activateResponse.data.errors[0].message);
      }
    } catch (error: any) {
      toast.error(error.data.errors[0].message);
    }
  };

  const addNewPlan = async (data) => {
    try {
      dispatch(fetchDataStart());
      const myResponse = await addPlanApi(appID, data);
      if (myResponse.data.status_code === 200) {
        toast.success(myResponse.data.result.message);
        const response = await getAppOverViewDetails(appID);
        dispatch(fetchDataSuccess(response));
        setPlansFromApi(response.plans);
        setEditedPlans(response.plans.map((plan: any) => ({ ...plan })));
      } else {
        toast.error(myResponse.data.errors[0].message);
      }
    } catch (e: any) {
      toast.error(e.data.errors[0].message);
    }
  };

  const editPlan = async (data) => {
    try {
      dispatch(fetchDataStart());
      const editResponse = await editPlanApi(appID, data);
      if (editResponse.data.status_code === 200) {
        toast.success(editResponse.data.result.message);
        const response = await getAppOverViewDetails(appID);
        dispatch(fetchDataSuccess(response));
        setPlansFromApi(response.plans);
        setEditedPlans(response.plans.map((plan: any) => ({ ...plan })));
      } else {
        toast.error(editResponse.data.errors[0].message);
      }
    } catch (error: any) {
      toast.error(error.data.errors[0].message);
    }
  };
  const handleNewPlan = async (newPlan) => {
    try {
      addNewPlan(newPlan);
    } catch (error) {
      console.error("Error handling new plan:", error);
    }
  };
  const handleSave = async (index: number) => {
    const updatedPlans = [...plansFromApi];
    updatedPlans[index] = { ...editedPlans[index] };
    setPlansFromApi(updatedPlans);
    setEditingPlanIndex(-1);

    updatedPlans[index].billing_cycle = parseInt(editedPlans[index].billing_cycle, 10) || 0;
    updatedPlans[index].shipment_cost = parseInt(editedPlans[index].shipment_cost, 10) || 0;
    if (editedPlans[index].percentage_value !== undefined) {
      updatedPlans[index].percentage_value = parseInt(editedPlans[index].percentage_value, 10) || 0;
    }

    const validityInt = parseInt(editedPlans[index].validity, 10) || 0;
    const currency = validityInt === 1001 ? "" : "INR";
    updatedPlans[index].currency = currency;

    switch (editedPlans[index].plan_type) {
      case "306":
        updatedPlans[index].plan_type = 306;
        updatedPlans[index].billing_cycle = 365;
        if (isNaN(validityInt) || validityInt === 0) {
          updatedPlans[index].validity = 1008;
        } else {
          updatedPlans[index].validity = validityInt;
        }
        break;
      case "303":
        updatedPlans[index].plan_type = 303;
        updatedPlans[index].billing_cycle = 1;
        if (isNaN(validityInt) || validityInt === 0) {
          updatedPlans[index].validity = 1004;
        } else {
          updatedPlans[index].validity = 1004;
        }
        break;
      case "304":
        updatedPlans[index].plan_type = 304;
        if (isNaN(validityInt) || validityInt === 0) {
          updatedPlans[index].validity = 1002;
        } else {
          updatedPlans[index].validity = validityInt;
        }
        break;
      case "307":
        updatedPlans[index].plan_type = 307;
        if (!updatedPlans[index].payment_type) {
          updatedPlans[index].payment_type = 0;
        }
        if (!updatedPlans[index].percentage_of) {
          updatedPlans[index].percentage_of = "Order Value";
        }
        if (isNaN(validityInt) || validityInt === 0) {
          updatedPlans[index].validity = 1003;
        } else {
          updatedPlans[index].validity = validityInt;
        }
        break;
      default:
        updatedPlans[index].plan_type = parseInt(editedPlans[index].plan_type, 10) || 0;
        if (isNaN(validityInt) || validityInt === 0) {
          updatedPlans[index].validity = 0;
        } else {
          updatedPlans[index].validity = validityInt;
        }
        break;
    }

    if (updatedPlans[index].plan_type === 304) {
      updatedPlans[index].payment_type = "flat";
      if (updatedPlans[index].billing_cycle === 90) {
        updatedPlans[index].validity = 1007;
      } else if (updatedPlans[index].billing_cycle === 365) {
        updatedPlans[index].validity = 1008;
      } else if (updatedPlans[index].billing_cycle === 30) {
        updatedPlans[index].validity = 1002;
      }
    }

    if (updatedPlans[index].plan_type === 306) {
      updatedPlans[index].payment_type = "flat";
      updatedPlans[index].validity = 1008;
      updatedPlans[index].billing_cycle = 365;
      updatedPlans[index].shipment_cost = 0;
    }

    if (updatedPlans[index].plan_type === 303) {
      updatedPlans[index].payment_type = "flat";
      if (!updatedPlans[index].billing_cycle || updatedPlans[index].billing_cycle === 0) {
        updatedPlans[index].billing_cycle = 1;
      }
      updatedPlans[index].validity = 1004;
    }

    if (updatedPlans[index].plan_type === 307) {
      if (!updatedPlans[index].billing_cycle || updatedPlans[index].billing_cycle === 0) {
        updatedPlans[index].billing_cycle = 1;
      }
      updatedPlans[index].billing_cycle = 1;
      if (isNaN(validityInt) || validityInt === 0) {
        updatedPlans[index].validity = 1003;
      }

      if (editedPlans[index].percentage_of === "") {
        updatedPlans[index].percentage_of = "Order Value";
      }
    }

    updatedPlans[index].validity = parseInt(updatedPlans[index].validity, 10) || 0;
    updatedPlans[index].shipment_cost = parseInt(updatedPlans[index].shipment_cost, 10) || 0;
    try {
      updatedPlans[index].features = updatedPlans[index].features.filter((feature: string | undefined) => {
        return feature && feature.trim() !== "";
      });
    } catch (e) {
      console.log("error in feature => " + e);
    }
    

    const existingPlan = updatedPlans[index].plan_id;
    if (existingPlan) {
      await editPlan(updatedPlans[index]);
    } else {
      await handleNewPlan(updatedPlans[index]);
    }
  };

  const handleInputChange = (index: number, key: string, value: string) => {
    const updatedPlan = { ...editedPlans[index], [key]: value };

    // Handle specific cases for plan_type and payment_type
    if (key === 'plan_type') {
      if (value === '303') {
        updatedPlan.validity = 1004;
        updatedPlan.billing_cycle = 1;
        setEnablePricePlans(true);
        setEnablePercentage(false);
        setEnablePaymentType(false);
        setEnablePlansChargeAt(false);
        setEnablePlansDuration(false);
      } else if (value === '306') {
        updatedPlan.billing_cycle = 365;
        setEnablePricePlans(false);
        setEnablePercentage(false);
        setEnablePaymentType(false);
        setEnablePlansChargeAt(false);
        setEnablePlansDuration(false);
      } else if (value === '307') {
        updatedPlan.billing_cycle = 1;
        setEnablePricePlans(true);
        setEnablePaymentType(true);
        setEnablePlansChargeAt(true);
        setEnablePlansDuration(false);
      } else if (value === '304') {
        setEnablePricePlans(true);
        setEnablePlansDuration(true);
        setEnablePercentage(false);
        setEnablePaymentType(false);
        setEnablePlansChargeAt(false);
      }
    }

    if (key === 'payment_type') {
      if (value === 'flat') {
        setEnableFlat(true);
        setEnablePercentage(false);
        setEnablePricePlans(true);
      } else if (value === 'percentage') {
        setEnablePercentage(true);
        setEnablePricePlans(false);
        
      }
    }

    if (key === 'percentage_of') {
      setEnablePricePlans(false);
      if (value === "Other") {
        setIsOtherPercentageValiditySelected(true);
        setEnablePricePlans(false);
      } else {
        setIsOtherPercentageValiditySelected(false);
      }
    }

    const updatedEditedPlans = [...editedPlans];
    updatedEditedPlans[index] = updatedPlan;

    setEditedPlans(updatedEditedPlans);
  };

  const handleFeatureEdit = (index: number, featureIndex: number, value: string) => {
    const updatedPlan = { ...editedPlans[index] };
    updatedPlan.features = [...(updatedPlan.features || [])];
    updatedPlan.features[featureIndex] = value;

    const updatedEditedPlans = [...editedPlans];
    updatedEditedPlans[index] = updatedPlan;

    setEditedPlans(updatedEditedPlans);
  };

  const handleEdit = (index: number) => {
    setEditingPlanIndex(index);
  };

  const handleAddPlan = () => {
    if (editingPlanIndex === -1) {
      const newPlan = {
        name: '',
        shipment_cost: 0,
        plan_type: 306,
        payment_type: 'flat',
        billing_cycle: 0,
        validity: 0,
        status: 'Inactive',
        features: ['']
      };
  
      if (newPlan.plan_type === 306) {
        newPlan.billing_cycle = 365;
      }
      if (newPlan.plan_type === 306 || (newPlan.plan_type === 303 && isNaN(newPlan.validity))) {
        newPlan.validity = 1008;
      }
  
      // Insert new plan at index 0
      const updatedPlansFromApi = [newPlan, ...plansFromApi];
      const updatedEditedPlans = [newPlan, ...editedPlans];
  
      setPlansFromApi(updatedPlansFromApi);
      setEditedPlans(updatedEditedPlans);
      setEditingPlanIndex(0);
    }
  };
  

  const handleToggleSwitch = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newStatus = event.target.checked ? "Active" : "Inactive";

    try {
      const updatedPlans = plansFromApi.map((p, idx) => {
        if (idx === index) {
          return { ...p, status: newStatus };
        }
        return p;
      });
      const updatedEditedPlans = editedPlans.map((p, idx) => {
        if (idx === index) {
          return { ...p, status: newStatus };
        }
        return p;
      });
      setPlansFromApi(updatedPlans);
      setEditedPlans(updatedEditedPlans);

      if (newStatus === "Inactive" && updatedEditedPlans[index].status === "Active") {
        const activePlans = updatedEditedPlans.filter(plan => plan.status === "Active");
        if (activePlans.length === 1) {
          toast.error("At least one plan must remain active.");
          return;
        }
      }

      const planIDs: string[] = [];
      for (let i = 0; i < updatedEditedPlans.length; i++) {
        if (updatedEditedPlans[i].status === "Active") {
          planIDs.push(updatedEditedPlans[i].plan_id);
        }
      }

      const activIds = { plan_id: planIDs };
      activatePlan(activIds);
      setEditingPlanIndex(-1);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const ensureFiveFeatures = (features) => {
    const featureCount = features.length;
    if (featureCount < 5) {
      return [...features, ...Array(5 - featureCount).fill('')];
    }
    return features;
  };

  return (
    <div className="developer-page-frame p-5" style={{ paddingTop: "25px", paddingLeft: "2.0rem", paddingRight: "2.0rem" }}>
      <ToastContainer style={{ top: "60px" }} />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
          Plans
        </label>
        {editingPlanIndex === -1 && plansFromApi.length < 100 && (
          <div style={{ fontFamily: "sfpromedium" }}>
            <Button
              onClick={handleAddPlan}
              accessibilityLabel="Add Plan"
              icon={PlusIcon}
            >
              Add new plan
            </Button>
          </div>
        )}
      </div>
      <div style={{ height: "20px" }}></div>
      <Card roundedAbove="xl">
        <div style={{ paddingBottom: "20px" }}>
          <BlockStack gap="100">
            <Text as="p" variant="bodyMd">
              Add variants if this product comes in multiple versions, like different sizes or colors.
            </Text>
          </BlockStack>
        </div>
        <div className={plansFromApi.length === 0 ? "" : "grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1"}>
          {plansFromApi.length === 0 ? (
            <div style={{ alignItems: "center" }}>
              <div>
                <img
                  src={"https://sr-track-plus-global-track-web-qa-1.kartrocket.com/assets/images/no_data.svg"}
                  style={{ display: "block", margin: "0 auto" }}
                  alt=""
                />
              </div>
              <div style={{ textAlign: "center" }}>
                No data found
              </div>
            </div>
          ) : (
            plansFromApi.map((plan: any, index: number) => {
              const isFlatPayment = editedPlans[index].payment_type === "flat";
              const isPercentagePayment = editedPlans[index].payment_type === "percentage";
              const isPlanType303 = editedPlans[index].plan_type === '303';
              const isPlanType304 = editedPlans[index].plan_type === '304';
              const isPlanType307 = editedPlans[index].plan_type === '307';
              const isPlanType306 = editedPlans[index].plan_type === '306';

              const enablePricePlans = isPlanType303 || isPlanType304 || (isPlanType307 && isFlatPayment);
              const enablePaymentType = isPlanType307;
              const enablePlansChargeAt = isPlanType307;
              const enablePlansDuration = (isPlanType304 || isPlanType307) && !isPlanType307;
              const enablePercentage = isPlanType307 && isPercentagePayment;

              const currentPlan = editingPlanIndex === index ? editedPlans[index] : plan;

              return (
                <div key={index} style={{ paddingBottom: "30px" }}>
                  <Card>
                    <BlockStack gap="100">
                      <InlineGrid columns="1fr auto">
                        <label>{plan.status}</label>
                        <div className="flex gap-2 items-center">
                          <Switch
                            checked={plan.status === "Active"}
                            onChange={(event) => handleToggleSwitch(event, index)}
                            color="primary"
                          />
                          {editingPlanIndex !== index ? (
                            <Button
                              onClick={() => handleEdit(index)}
                              accessibilityLabel={`Edit ${plan.name}`}
                              icon={EditIcon}
                            />
                          ) : (
                            <Button onClick={() => handleSave(index)}>Save Plan</Button>
                          )}
                        </div>
                      </InlineGrid>
                    </BlockStack>
                    <div className="flex flex-col md:flex-row textbox-h select-h gap-8">
                      <div className="w-full md:w-1/2 p-4">
                        <div className="pb-4">
                          <TextField
                            disabled={editingPlanIndex !== index}
                            label="Plan Name"
                            autoComplete="Plan Name"
                            value={currentPlan.name}
                            onChange={(value) => handleInputChange(index, 'name', value)}
                          />
                        </div>
                        <div>
                          <div>
                            <Label id={''}>Feature</Label>
                          </div>
                          {ensureFiveFeatures(currentPlan.features || []).map((feature: string, featureIndex: number) => (
                            <div key={featureIndex} className="pb-4">
                              <TextField
                                maxLength={100}
                                showCharacterCount
                                disabled={editingPlanIndex !== index}
                                key={featureIndex}
                                label
                                placeholder={`Feature ${featureIndex + 1}`}
                                autoComplete={`Feature ${featureIndex + 1}`}
                                value={feature}
                                onChange={(value) => handleFeatureEdit(index, featureIndex, value)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="w-full md:w-1/2 p-4">
                        <div className="pt-0">
                          <Select
                            disabled={editingPlanIndex !== index}
                            label="Plan Type"
                            options={[
                              { label: "Free", value: "306" },
                              { label: "One Time Purchase", value: "303" },
                              { label: "Subscription", value: "304" },
                              { label: "Pay as you Go", value: "307" },
                            ]}
                            onChange={(value) => handleInputChange(index, 'plan_type', value)}
                            value={String(currentPlan.plan_type)}
                          />
                        </div>
                        {(currentPlan.plan_type === 307 || enablePlansChargeAt) && (
                          <div>
                            <div className="pt-4">
                              <Select
                                disabled={editingPlanIndex !== index}
                                label="Charge At"
                                options={[
                                  { label: "Per Order", value: "1003" },
                                  { label: "Per Shipment", value: "1009" },
                                  { label: "Per Delivered Order", value: "1010" },
                                  { label: "Per Transaction", value: "1011" },
                                ]}
                                onChange={(value) => handleInputChange(index, "validity", value)}
                                value={(currentPlan.validity==="Per Order"?"1003":currentPlan.validity==="Per Shipment"?"1009":currentPlan.validity==="Per Delivered Order"?"1010":currentPlan.validity==="Per Transaction"?"1011":currentPlan.validity)}
                              />
                            </div>
                            {currentPlan.validity === "1006" && (
                              <div className="pt-4">
                                <TextField
                                  disabled={editingPlanIndex !== index}
                                  label
                                  placeholder="Other Validity"
                                  autoComplete="Other Validity"
                                  value={otherValidityValue}
                                  onChange={(value) => setOtherValidityValue(value)}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {(currentPlan.plan_type === 304 || enablePlansDuration) && (
                          <div className="pt-4">
                            <Select
                              disabled={editingPlanIndex !== index}
                              label="Plan Duration"
                              options={[
                                { label: "Monthly", value: "30" },
                                { label: "Quarterly", value: "90" },
                                { label: "Yearly", value: "365" },
                              ]}
                              onChange={(value) => handleInputChange(index, 'billing_cycle', value)}
                              value={String(currentPlan.billing_cycle)}
                            />
                          </div>
                        )}
                        {(currentPlan.plan_type === 307 || enablePlansChargeAt) && (
                          <div className="pt-4">
                            <Select
                              disabled={editingPlanIndex !== index}
                              label="Payment Type"
                              options={[
                                { label: "Flat", value: "flat" },
                                { label: "Percentage", value: "percentage" },
                              ]}
                              onChange={(value) => handleInputChange(index, 'payment_type', value)}
                              value={currentPlan.payment_type}
                            />
                            {(currentPlan.payment_type === "percentage" || enablePercentage) && (
                              <div style={{ paddingTop: "15px" }} className="pt-4">
                                <TextField
                                  disabled={editingPlanIndex !== index}
                                  label="Percentage Value"
                                  autoComplete="Percentage Value"
                                  value={currentPlan.percentage_value ?? 0}
                                  onChange={(value) => handleInputChange(index, 'percentage_value', value)}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {(currentPlan.plan_type === 307 && currentPlan.payment_type === "percentage"||enablePercentage) && (
                          <div className="pt-4">
                            <Select
                              disabled={editingPlanIndex !== index}
                              label="Percentage of"
                              options={[
                                { label: "Order Value", value: "Order Value" },
                                { label: "Abandoned Value", value: "Abandoned Value" },
                                { label: "Other", value: "Other" },
                              ]}
                              onChange={(value) => handleInputChange(index, 'percentage_of', value)}
                              value={currentPlan.percentage_of}
                            />
                            {currentPlan.percentage_of === "Other" && (
                              <div style={{ paddingTop: "15px" }} className="pt-4">
                                <TextField
                                  disabled={editingPlanIndex !== index}
                                  label
                                  placeholder="Other Validity"
                                  autoComplete="Other Validity"
                                  value={currentPlan.other_validity || ''}
                                  onChange={(value) => handleInputChange(index, 'other_validity', value)}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {(currentPlan.plan_type === 304 || currentPlan.plan_type === 303 || (currentPlan.plan_type === 307 && currentPlan.payment_type === "flat") || enablePricePlans) && (
                          <div className="pb-4 pt-4">
                            <TextField
                              disabled={editingPlanIndex !== index}
                              label="Amount"
                              autoComplete="Amount"
                              value={`${currentPlan.shipment_cost}`}
                              onChange={(value) => handleInputChange(index, 'shipment_cost', value)}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })
          )}
        </div>
      </Card>
    </div>
  );
};

export default DevPlan;
